import { useContext } from "react";

import ScheduleSystemsContext from "../context/ScheduleSystemsProvider";

const useScheduleSystems = () => {
  return useContext(ScheduleSystemsContext);
};

export default useScheduleSystems;
